module.exports = __webpack_public_path__ + "site/img/children.344c9bb8.png";